
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"22","viewBox":"0 0 33 27","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.782 24.273c0 .723-.252 1.34-.755 1.85s-1.122.765-1.855.765c-.734 0-1.352-.255-1.855-.766L0 13.608 12.328 1.105c.503-.51 1.121-.764 1.855-.764.733 0 1.352.256 1.855.766.502.51.753 1.138.753 1.883 0 .744-.253 1.372-.755 1.882l-5.976 6.124 19.869.009c.712 0 1.32.255 1.823.765.493.489.766 1.158.754 1.852 0 .724-.253 1.35-.755 1.882-.504.531-1.112.798-1.824.798l-19.87-.009 5.972 6.128c.493.488.766 1.157.753 1.85","fill":"#ffa306","fill-rule":"nonzero"}})])
          )
        }
      }
    